import { Drawer, SimpleToolbar, Loader, Toast } from "../../../components";
import { Grid, Container, makeStyles } from "@material-ui/core";
import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useState, useEffect } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { laboratoryServices } from "../../../services";
import RefillCategoryForm from "../../../components/refill/refill-category-form";
import BasalCategoryForm from "../../../components/refill/basal-category-form";

export default function UpdateRefillCategoryScreen() {
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ open: false, message: "" });
  const [refillCategory, setRefillCategory] = useState(null);
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const categoryId = query.get("c");
  const type = query.get("t");

  async function getRefillCategories() {
    laboratoryServices
      .getRefillCategories({
        laboratoryId: authState.user.laboratory._id,
        token: authState.token,
      })
      .then((res) => {
        if (res.status === 200) {
          const categories = res.response;
          const foundCategory = categories.find((c) => c._id === categoryId);
          setRefillCategory(foundCategory || null);
          // console.log(res.response);
        } else {
          setToast(() => ({ open: true, message: "Ha ocurrido un error" }));
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }
  useEffect(() => {
    getRefillCategories();
  }, []);
  const handleOnSubmit = async (formData, _) => {
    const data = {
      productsRefillCategoryId: refillCategory._id,
      name: formData.name,
      status: formData.status ?? "active",
      ...(type === "basal" ? { refillTo: formData.refillTo } : {}),
      products: formData.products ?? [],
    };
    try {
      setLoading(true);
      const { status, response } = await
        laboratoryServices.editProductsRefillCategories({
          token: authState.token,
          data,
        });
        // console.log(status,response);
        
      if (status === 200|| !!response.message) {
        setToast({ open: true, message: "Categoria actualizada exitosamente" });
        setTimeout(() => {
          history.replace("/refill");
        }, 500);
      }else
      setToast({
        open: true,
        message: "No se ha podido actualizar la categoria",
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast.open}
          message={toast.message}
          close={() => setToast({ open: false, message: "" })}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>

          <Container
            maxWidth={"md"}
            component={"main"}
            className={classes.container_main}
          >
            {type === "basal" ? (
              <BasalCategoryForm
                isEdit={true}
                data={refillCategory}
                onSubmit={(data) => handleOnSubmit(data)}
              />
            ) : (
              <RefillCategoryForm
                isEdit={true}
                data={refillCategory}
                onSubmit={(data) => handleOnSubmit(data)}
              />
            )}
          </Container>
        </Grid>
      </Grid>
    </>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  container_main: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    height: "100%",
  },
}));
